<template>
    <div id="awaitingTickets">
        <a-table
            :columns="columns()"
            :dataSource="waitingChatGetter"
            :locale="{
                emptyText: $t('message.noVisitorFound'),
            }"
            :pagination="false"
            class="custom-table2"
            rowKey="_id"
            size="small"
            @change="toggleSortOrder"
        >
            <div slot="email" slot-scope="_, item">
                {{ getVisitorValue(item, "email") }}
            </div>
            <div slot="phone" slot-scope="_, item">
                {{ getVisitorValue(item, "phone") }}
            </div>
            <div slot="name" slot-scope="_, item">
                {{
                    !!item.conversation
                        ? item.conversation.fullname || "-"
                        : !!item.osrPayload
                        ? item.osrPayload.fullname
                        : "-"
                }}
            </div>
            <div slot="createdDate" slot-scope="createdDate">
                {{ createdDate | date }}
            </div>
            <div slot="assignedUser" slot-scope="assignedUser, item">
                <a-select
                    :default-value="assignedUser ? assignedUser._id : null"
                    class="ticket-select"
                    @change="(value) => handleChange(value, item._id)"
                >
                    <a-select-option v-for="user in users.data" :key="user._id" :value="user._id">
                        {{ user.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div slot="status" slot-scope="status, item">
                <a-select
                    :default-value="!!status ? status : null"
                    class="ticket-select"
                    @change="(value) => handleChangeStatus(item._id, value)"
                >
                    <a-select-option v-for="status in statuses" :key="status._id" :value="status.title">
                        {{ status.title }}
                    </a-select-option>
                </a-select>
            </div>

            <div slot="_id" slot-scope="_id, item">
                <div class="d-flex w-100 justify-content-start">
                    <a-button
                        v-if="checkPermission(PERMISSION_TYPES['offlineSupportRequest.update'].tr.name)"
                        class="actionButton d-flex align-items-center"
                        @click="view(item)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('message.sendResponse')"
                    >
                        <ActionEdit />
                    </a-button>
                    <a-button
                        v-if="checkPermission(PERMISSION_TYPES['offlineSupportRequest.delete'].tr.name)"
                        class="actionButton d-flex align-items-center"
                        @click="archived(item)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('message.archived')"
                    >
                        <md-icon style="color: #3fc5bd">inventory_2</md-icon>
                    </a-button>
                </div>
            </div>
        </a-table>
        <div class="d-flex justify-content-end mt-3" style="margin-bottom: 100px">
            <Pagination
                :page-change="pageChange"
                :page-sizes="pageSizes"
                :total="waitingTickets.totalPages * perPage"
                pageSizeLocalStorageKey="ticket-page-size"
            />
        </div>
        <Modal2
            v-if="isModalShow"
            id="awaiting-message-details"
            :title="$t('message.historyDetails')"
            :show-footer="false"
            @cancel="hideModal"
        >
            <b-tabs content-class="mt-3">
                <b-tab :title="$t('message.chat')" active>
                    <div v-if="selectedHistory.type === 'osr'">
                        <p class="p-2">{{ selectedHistory.messages }}</p>
                        <quill-editor v-model="responseText" @change="onEditorChange($event)" :options="editorOption" />
                        <b-row class="mt-4">
                            <b-col md="12">
                                <b-button class="float-right" @click="hideModal">
                                    <template>
                                        {{ $t("message.cancel") }}
                                    </template>
                                </b-button>
                                <b-button
                                    :disabled="responseSending"
                                    class="float-right mr-2"
                                    variant="primary"
                                    @click="sendResponse"
                                >
                                    <template v-if="!responseSending">
                                        {{ $t("message.send") }}
                                    </template>

                                    <template v-else>
                                        <font-awesome-icon icon="spinner" spin />
                                        {{ $t("message.sending") }}...
                                    </template>
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <div v-if="filteredMessages.length" style="display: flex; flex-direction: column">
                            <div v-if="filteredMessages.length" v-chat-scroll class="waiting-ticket-messages">
                                <MessageList
                                    :contextMenuVisable="false"
                                    :always-scroll-to-bottom="false"
                                    :colors="colors"
                                    :messages="getMessages()"
                                    :participants="getParticipants()"
                                />
                            </div>
                            <quill-editor
                                v-model="responseText"
                                @change="onEditorChange($event)"
                                :options="editorOption"
                            />
                            <b-row class="mt-4">
                                <b-col md="12">
                                    <b-button class="float-right" @click="hideModal">
                                        <template>
                                            {{ $t("message.cancel") }}
                                        </template>
                                    </b-button>
                                    <b-button
                                        :disabled="responseSending"
                                        class="float-right mr-2"
                                        variant="primary"
                                        @click="sendResponse"
                                    >
                                        <template v-if="!responseSending">
                                            {{ $t("message.send") }}
                                        </template>

                                        <template v-else>
                                            <font-awesome-icon icon="spinner" spin />
                                            {{ $t("message.sending") }}...
                                        </template>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
                        </div>
                    </div>
                </b-tab>
                <b-tab v-if="!!isVisitorExist()" :title="$t('message.visitorInfo')">
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.fullName") }}
                        </div>
                        <div class="userInfo sec">
                            {{ visitorInfo.fullname }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.email") }}
                        </div>
                        <div class="userInfo sec">
                            {{ visitorInfo.email }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.phone") }}
                        </div>
                        <div class="userInfo sec">
                            {{ visitorInfo.phone }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">IP</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.ipAddress || "-" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.browser") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.browser || "-" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">{{ $t("message.os") }}</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.os || "-" }}
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </Modal2>
    </div>
</template>

<script>
import Pagination from "./Pagination";
import ActionDelete from "./svg/ActionDelete";
import ActionEdit from "./svg/ActionEdit";
import { tableSorter } from "../utils/utils";
import { mapActions, mapGetters, mapState } from "vuex";
import * as _ from "lodash";
import moment from "moment";
import { log2 } from "../utils/log2";
import MessageList from "./popup-chat/MessageList";
import { toNewMessagesModel } from "../utils/chat";
import { getPersistenceData } from "../utils/persistenceStorage";
import { addTicketStatus } from "../api/ticket";
import systemPubSub from "../utils/systemPubSub";
import { filter } from "rxjs/operators";
import Modal2 from "./common/Modal2";
import { PERMISSION_TYPES } from "../language/permissionTypes";

const log = log2("AwaitingTickets");
export default {
    name: "AwaitingTickets",
    components: {
        Pagination,
        ActionDelete,
        ActionEdit,
        MessageList,
        Modal2,
    },
    props: {
        tag: { type: String },
        statuses: { type: Array },
        showMyTickets: { type: Boolean },
    },
    data() {
        return {
            page: 1,
            perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                ? parseInt(getPersistenceData("ticket-page-size"))
                : 10,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            pageSizes: ["10", "25", "50", "100"],
            columns: () => [
                {
                    title: this.$t("headBar.email"),
                    slot: "email",
                    scopedSlots: { customRender: "email" },
                    ...tableSorter("conversation.email", "number", this.currentSort),
                },
                {
                    title: this.$t("headBar.phone"),
                    slot: "phone",
                    scopedSlots: { customRender: "phone" },
                    ...tableSorter("conversation.phone", "number", this.currentSort),
                },
                {
                    title: this.$t("headBar.name"),
                    slot: "name",
                    scopedSlots: { customRender: "name" },
                    ...tableSorter("conversation.fullName", "string", this.currentSort),
                },
                {
                    dataIndex: "createdDate",
                    title: this.$t("headBar.date"),
                    scopedSlots: { customRender: "createdDate" },
                    slot: "createdDate",
                    ...tableSorter("createdDate", "date", this.currentSort),
                },
                {
                    title: this.$t("headBar.subject"),
                    dataIndex: "tag",
                    key: "tag",
                    ...tableSorter("tag", "string", this.currentSort),
                },
                {
                    dataIndex: "status",
                    title: this.$t("headBar.situation"),
                    scopedSlots: { customRender: "status" },
                    key: "status",
                    ...tableSorter("status", "string", this.currentSort),
                },
                {
                    dataIndex: "assignedUser",
                    title: this.$t("headBar.representative"),
                    scopedSlots: { customRender: "assignedUser" },
                    slot: "assignedUser",
                    width: "10%",
                    ...tableSorter("assignedUser.name", "string", this.currentSort),
                },
                {
                    dataIndex: "_id",
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "_id" },
                    slot: "_id",
                    width: "15%",
                    ...tableSorter("_id", "string", this.currentSort),
                },
            ],
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            selectedHistory: {
                visitor: {},
                messages: [],
                ticket: {},
                type: null,
            },
            responseSending: false,
            responseText: "",
            assignedUser: null,
            unSubs: [],
            editorOption: {
                // Some Quill options...
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        ["link"],
                    ],
                },
            },
            isModalShow: false,
        };
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            waitingTickets: (state) => state.ticket.waitingTickets,
            topics: (state) => state.ticket.topics,
            users: (state) => state.user.users,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            waitingChatGetter: "ticket/getWaitingTickets",
            getUser: "user/getUser",
            checkPermission: "auth/checkPermission",
        }),
        filteredMessages() {
            log(
                "filteredMessages",
                this.selectedHistory.messages,
                this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type)
            );
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
        visitorInfo() {
            if (!this.isVisitorExist())
                return {
                    email: "-",
                    fullname: "-",
                };
            if (this.selectedHistory.type === "osr") return this.selectedHistory.ticket.osrPayload;
            if (!!this.selectedHistory.visitor.email && !!this.selectedHistory.visitor.fullname)
                return this.selectedHistory.visitor;
            if (
                !!this.selectedHistory.ticket.conversation &&
                !!this.selectedHistory.ticket.conversation.email &&
                !!this.selectedHistory.ticket.conversation.fullname
            )
                return this.selectedHistory.ticket.conversation;
            return {
                email: "-",
                fullname: "-",
            };
        },
    },
    methods: {
        ...mapActions({
            fetchWaitingTickets: "ticket/fetchWaitingTickets",
            assignRepresentative: "ticket/assignRepresentative",
            getUsers: "user/getUsers",
            loadOldMessages: "chat/loadOldMessages",
            sendTicketResponse: "ticket/sendTicketResponse",
        }),
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
        },
        onEditorChange({ quill, html, text }) {
            log.debug("editor change!", { a: quill, b: html, c: text });
            this.responseText = html;
        },
        getVisitorValue(item, field) {
            if (field === "email") log("getVisitorValue", item, field);
            let value = !!item.conversation
                ? item.conversation[field] || "-"
                : !!item.osrPayload
                ? item.osrPayload[field]
                : "-";
            if (item.createdByChatbot) {
                if (field === "email") {
                    value = item.visitorEmailAddress || value;
                }
                if (field === "phone") {
                    value = item.visitorPhoneNumber || value;
                }
            }
            return value;
        },
        handleChange(repId, _id) {
            this.assignRepresentative({ _id, repId });
        },
        handleChangeStatus(id, title) {
            addTicketStatus({ id, title });
        },
        pageChange(page, perPage) {
            log("pageChange", { page, perPage });
            this.page = page;
            this.perPage = perPage;
        },
        isVisitorExist() {
            const visitor = _.get(this.selectedHistory, "visitor", {}) || {};
            const visitorKeys = Object.keys(visitor);
            return visitorKeys.length || [].length;
        },
        view(item) {
            this.selectedHistory.ticket = item;
            this.selectedHistory.visitor = item.visitor;
            if (!!item.osrPayload) {
                this.selectedHistory.messages = item.osrPayload.message;
                this.selectedHistory.type = "osr";
                /*this.$bvModal.show("awaiting-message-details");*/
                this.showModal();
            } else {
                this.loadOldMessages(item.conversation._id).then((response) => {
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                        (q) => moment(q.createdDate).toDate().getTime(),
                        "asc"
                    );
                    this.selectedHistory.messages = items;
                    /*this.$bvModal.show("awaiting-message-details");*/
                    this.showModal();
                });
            }
        },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);

            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        reset() {
            this.selectedHistory = {
                visitor: {},
                messages: [],
                ticket: {},
            };
            this.responseText = "";
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        sendResponse() {
            let data = {
                _id: this.selectedHistory.ticket._id,
                repId: this.user._id,
                response: this.responseText,
            };
            this.sendTicketResponse(data).then((x) => {
                /*this.$bvModal.hide("awaiting-message-details");*/
                this.responseText = "";
                this.hideModal();
            });
        },
        archived(item) {
            let data = {
                _id: item._id,
                repId: this.user._id,
                response: `Archived by ${this.user.name}`,
            };
            this.sendTicketResponse(data);
        },
        toggleSortOrder(columnKey) {
            if (this.currentSort.columnKey === columnKey) {
                this.currentSort.order = this.currentSort.order === "ascend" ? "descend" : "ascend";
            } else {
                this.currentSort.columnKey = columnKey;
                this.currentSort.order = "ascend";
            }
        },
    },
    mounted() {
        this.toggleSortOrder("createdDate");
        this.fetchWaitingTickets({
            page: this.page,
            perPage: this.perPage,
            tag: this.tag,
            assignedUser: this.assignedUser,
        });
        /*this.refreshTimerId = setInterval(() => {
            this.fetchWaitingTickets({
                page: this.page,
                perPage: this.perPage,
                tag: this.tag,
                assignedUser: this.assignedUser,
            });
        }, 1000 * 10);*/
        const newTicketSub = systemPubSub.stream.pipe(filter((x) => x.type === "ticket_message")).subscribe((x) => {
            this.fetchWaitingTickets({
                page: this.page,
                perPage: this.perPage,
                tag: this.tag,
                assignedUser: this.assignedUser,
            });
        });
        this.unSubs.push(() => newTicketSub.unsubscribe());
        this.getUsers({
            page: 1,
            perPage: 1000,
        });
    },
    beforeDestroy() {
        this.unSubs.forEach((sub) => sub());
        clearInterval(this.refreshTimerId);
    },
    watch: {
        page(newValue) {
            this.fetchWaitingTickets({
                page: newValue,
                perPage: this.perPage,
                tag: this.tag,
                assignedUser: this.assignedUser,
            });
        },
        perPage(newValue) {
            this.fetchWaitingTickets({
                page: this.page,
                perPage: newValue,
                tag: this.tag,
                assignedUser: this.assignedUser,
            });
        },
        tag(newValue) {
            this.fetchWaitingTickets({
                page: this.page,
                perPage: this.perPage,
                tag: newValue,
                assignedUser: this.assignedUser,
            });
        },
        showMyTickets(newValue) {
            if (newValue) {
                this.assignedUser = this.user._id;
                this.fetchWaitingTickets({
                    page: this.page,
                    perPage: this.perPage,
                    tag: this.tag,
                    assignedUser: this.assignedUser,
                });
            } else {
                this.assignedUser = null;
                this.fetchWaitingTickets({
                    page: this.page,
                    perPage: this.perPage,
                    tag: this.tag,
                    assignedUser: this.assignedUser,
                });
            }
        },
    },
};
</script>

<style lang="scss">
#awaitingTickets {
    .ticket-select {
        width: 100%;

        .ant-select-selection {
            border-color: transparent !important;
        }
    }

    .custom-table {
        background-color: #ffffff;
        border-radius: 6px;
        padding: 10px 20px;
    }

    .ant-table-column-sorters,
    .ant-table-header-column {
        width: 100%;
    }

    .ant-table-header-column {
        padding: 0 10px;
    }

    .table-custom,
    .ant-table-placeholder,
    .ant-table-small {
        border: none;
    }

    .ant-table-thead tr {
    }

    .ant-table-body {
        tr {
        }

        td {
            padding: 0 8px !important;
            font-size: 12px;
            font-weight: 300;
            color: #181c32;
            border-bottom: none;
        }

        th {
            border-right: 1px solid #ebedf3;
            border-bottom: none;
            padding: 0 !important;

            &:last-child {
                border-right: none;
            }
        }
    }

    .ant-table-body tbody td {
        border-right: 1px solid #ebedf3;

        &:last-child {
            border-right: none;
        }
    }

    .ant-table-column-title {
        color: #181c32;
        font-size: 13px;
        font-weight: 300;
        font-family: Poppins;
        white-space: nowrap;
    }

    .actionButton {
        border: none;
        box-shadow: none;
    }
}

.userInfo {
    font-family: Poppins;

    &.first {
        color: #3699ff;
        font-size: 16px;
        font-weight: 500;
        padding-top: 15px;
        line-height: 1;
    }

    &.sec {
        color: #181c32;
        font-size: 14px;
        font-weight: 300;
    }
}

.waiting-ticket-messages {
    max-height: 550px !important;
    overflow: scroll;
}

#awaiting-message-details {
    .ant-modal {
        width: 530px !important;
    }
}
</style>
